import type {ComponentProps} from 'react';
import {cn} from '../lib/cn';
import {TableFilter} from './TableFilter';

function DateTableFilter({className, ...props}: ComponentProps<typeof TableFilter>) {
  return (
    <TableFilter
      className={cn(
        `w-auto min-w-[82px] pr-6 text-[13px] max-[850px]:h-auto max-[850px]:max-w-[110px]
        max-[850px]:whitespace-break-spaces max-[850px]:leading-5`,
        className,
      )}
      {...props}
    />
  );
}

export {DateTableFilter};
